export const UserPermission = {
    Dashboard: {
        Read: "Dashboard.Read"
    },
    User: {
        Read: "User.Read",
        Write: "User.Write",
        Delete: "User.Delete"
    },
    Roles: {
        Read: "UserRole.Read",
        Write: "UserRole.Write",
        Delete: "UserRole.Delete"
    },
    Profile: {
        Read: "UserProfile.Read",
    },

    Customer: {
        Read: 'Customer.Read',
        Write: 'Customer.Write',
        Delete: 'Customer.Delete',
    },

    RepairWork: {
        Read: "RepairWork.Read"
    },

    OldGoldPurchaseRate: {
        Read: "OldGoldPurchaseRate.Read"
    },
    ReturnDeduction: {
        Read: "ReturnDeduction.Read"
    },
    GoldMakingCharges: {
        Read: "GoldMakingCharges.Read"
    },
    DiamondMakingCharges: {
        Read: "DiamondMakingCharges.Read"
    },
    ConsumerOffers: {
        Read: "ConsumerOffers.Read"
    },
    PromoMaster: {
        Read: "PromoMaster.Read"
    },
    FAQMaster: {
        Read: 'FAQMaster.Read',
        Write: 'FAQMaster.Write',
        Delete: 'FAQMaster.Delete',
    },
    StoreExpence: {
        Read: 'StoreExpence.Read',
        Write: 'StoreExpence.Write'
    },
    Store: {
        Read: 'Store.Read'
    },
    BillSetting: {
        Read: 'BillSetting.Read'
    },
    GoldRate: {
        Read: 'GoldRate.Read',
        Write: 'GoldRate.Write',
    },
    BirthdayAnniversary: {
        Read: 'BirthdayAnniversary.Read',
        Write: 'BirthdayAnniversary.Write',
    },

    EodTarget: {
        Read: 'EodTarget.Read',
    },
    RazorpayConfig: {
        Read: 'RazorpayConfig.Read',
        Write: 'RazorpayConfig.Write',
        Delete: 'RazorpayConfig.Delete',
    },
    BillType: {
        Read: 'BillType.Read'
    }, SalesPerson: {
        Read: 'SalesPerson.Read',
        Write: 'SalesPerson.Write',
        Delete: 'SalesPerson.Delete',
    },
    Inventory: {
        Read: 'Inventory.Read',
        Write: 'Inventory.Write',
    },
    Inward: {
        Read: 'Inward.Read',
        Write: 'Inward.Write',
    },
    SalesInventory: {
        Read: 'SalesInventory.Read',
        Write: 'SalesInventory.Write',
    },
    CashEntry: {
        Read: 'CashEntry.Read',
        Write: 'CashEntry.Write',
        Delete: 'CashEntry.Delete',
    },
    Repair: {
        Read: 'Repair.Read',
        Write: 'Repair.Write',
    },
    OldGoldPurchase: {
        Read: 'OldGoldPurchase.Read',
        Write: 'OldGoldPurchase.Write',
    },
    SalesEntry: {
        Read: 'SalesEntry.Read',
        Write: 'SalesEntry.Write',
    },
    ReturnSalesOrder: {
        Read: 'OldGoldPurchase.Read',
        Write: 'OldGoldPurchase.Write',
    }, FAQ: {
        Read: 'FAQ.Read',
    },
    Enquiry: {
        Read: 'Enquiry.Read',
    },

    CustomerWalkIn: {
        Read: 'CustomerWalkIn.Read',
        Write: 'CustomerWalkIn.Write',
    }, ReturnToHK: {
        Read: 'ReturnToHK.Read',
        Write: 'ReturnToHK.Write',
    }, HORecall: {
        Read: 'HORecall.Read',
        Write: 'HORecall.Write',
        Approve: 'HORecall.Approve',
        ManageSettings: 'HORecall.ManageSettings',
        ViewInventory: 'HORecall.ViewInventory',
        ViewRequests: 'HORecall.ViewRequests',
    }, DiscountVoucher: {
        Read: 'DiscountVoucher.Read',
        Write: 'DiscountVoucher.Write',
    }, PaymentType: {
        Read: 'PaymentType.Read',
        Write: 'PaymentType.Write',
    }, RewardRedemption: {
        Read: 'RewardRedemption.Read',
        Write: 'RewardRedemption.Write',
    }, WalkInSource: {
        Read: 'WalkInSource.Read',
    }, StoreOpsRole: {
        Read: 'StoreOpsRole.Read',
        Write: 'StoreOpsRole.Write',
    }, ReturnSalesOrders: {
        Read: 'ReturnSalesOrder.Read',
    }, PhysicalVerification: {
        Read: 'PhysicalVerification.Read'
    }, PhysicalVerificationList: {
        Read: 'PhysicalVerificationList.Read'
    }, EcomShipmentOrder: {
        Read: 'EcomShipmentOrder.Read',
        Write: 'EcomShipmentOrder.Write',
    }, DigitalGold: {
        Read: 'DigitalGold.Read',
    }, SIS: {
        Read: 'SIS.Read',
        Write: 'SIS.Write',
    }, ProductHistory: {
        Read: 'ProductHistory.Read',
        Write: 'ProductHistory.Write',
    }, GoldRateProtection: {
        Read: 'GoldRateProtection.Read',
        Write: 'GoldRateProtection.Write',
    },
    CustomerRefund: {
        Read: 'Refund.Read',
        Write: 'Refund.Write',
        Delete: 'Refund.Delete',
    },
    KYCVerification: {
        Read: 'KYCVerification.Read',
        Write: 'KYCVerification.Write',
    },
    EstimatePayment: {
        Read: 'EstimatePayment.Read',
        Write: 'EstimatePayment.Write'
    },
    InterstoreTransfer: {
        Read: 'InterstoreTransfer.Read',
        Write: 'InterstoreTransfer.Write',
    }, Reports: {
        Read: 'Reports.Read',
    },
    NotificationCenter: {
        Write: 'NotificationCenter.Write'
    },
    GDMakingCharge: {
        Read: 'GDMakingCharge.Read'
    },
    ShipToLocationMaster: {
        Read: 'ShipToLocationMaster.Read',
        Write: 'ShipToLocationMaster.Write',
    },
    Shipment: {
        ViewOpenTransactions: 'Shipment.ViewOpenTransactions',
        Create: 'Shipment.Create',
        ViewAllInward: 'Shipment.ViewAllInward',
        Inward: 'Shipment.Inward',
        ViewReturnShipments: 'Shipment.ViewReturnShipments',
        AcceptReturn: 'Shipment.AcceptReturn',
        ViewRaisedShipments: 'Shipment.ViewRaisedShipments',
    },
    Grn: {
        ViewReturnToHO: 'Grn.ViewReturnToHO',
        ViewHORecall: 'Grn.ViewHORecall',
        ViewOGRequest: 'Grn.ViewOGRequest',
        ViewSISRequest: 'Grn.ViewSISRequest',
        ViewRepair: 'Grn.ViewRepair',
        AcceptReject: 'Grn.AcceptReject',
    },
    KisnaLiveDashboard: {
        Read: 'KisnaLiveDashboard.Read',
        Overview: 'KisnaLiveDashboard.Overview.Read',
        SalesIntelligence: 'KisnaLiveDashboard.SalesIntelligence.Read',
        Targets: 'KisnaLiveDashboard.Targets.Read',
        Staff: 'KisnaLiveDashboard.Staff.Read',
        Inventory: 'KisnaLiveDashboard.Inventory.Read',
        GoldExchange: 'KisnaLiveDashboard.GoldExchange.Read',
        Customers: 'KisnaLiveDashboard.Customers.Read',
        Alerts: 'KisnaLiveDashboard.Alerts.Read',
        AomSummary: 'KisnaLiveDashboard.AomSummary.Read',
        KmrScheme: 'KisnaLiveDashboard.KmrScheme.Read',
        KisnaForce: 'KisnaLiveDashboard.KisnaForce.Read',
        StoreView: 'KisnaLiveDashboard.StoreView.Read',
        Fya: 'KisnaLiveDashboard.Fya.Read',
        Incentive: 'KisnaLiveDashboard.Incentive.Read',
    },
    LongShotAudit: {
        Read: 'LongShotAudit.Read',
        Export: 'LongShotAudit.Export',
        Documents: 'LongShotAudit.Documents',
        CorrectionWrite: 'LongShotAudit.CorrectionWrite',
        CorrectionReview: 'LongShotAudit.CorrectionReview',
        CorrectionRollback: 'LongShotAudit.CorrectionRollback',
        UserManagement: 'LongShotAudit.UserManagement',
    },
    IncentiveReport: {
        Read: 'IncentiveReport.Read',
    },
    Kmr: {
        CustomerPlans: { Read: 'Kmr.CustomerPlans.Read', Write: 'Kmr.CustomerPlans.Write' },
        PlanSchemes: { Read: 'Kmr.PlanSchemes.Read' },
        AdminCustomerPlans: { Read: 'Kmr.AdminCustomerPlans.Read' },
        MaturedPlansReport: { Read: 'Kmr.MaturedPlansReport.Read' },
        FranchiseWiseEnrollmentReport: { Read: 'Kmr.FranchiseWiseEnrollmentReport.Read' },
        AllUserReport: { Read: 'Kmr.AllUserReport.Read' },
        FranchiseWiseSummaryReport: { Read: 'Kmr.FranchiseWiseSummaryReport.Read' },
        DayToDayCollectionReport: { Read: 'Kmr.DayToDayCollectionReport.Read' },
        FranchiseLedgerReport: { Read: 'Kmr.FranchiseLedgerReport.Read' },
        UserSummaryReport: { Read: 'Kmr.UserSummaryReport.Read' },
        MonthlyPaymentReport: { Read: 'Kmr.MonthlyPaymentReport.Read' },
        AbandonedPaymentReport: { Read: 'Kmr.AbandonedPaymentReport.Read' },
        RedemptionReport: { Read: 'Kmr.RedemptionReport.Read' },
        InstallmentCollectionReport: { Read: 'Kmr.InstallmentCollectionReport.Read' },
        DeletedUserPaymentReport: { Read: 'Kmr.DeletedUserPaymentReport.Read' },
        UserList: { Read: 'Kmr.UserList.Read' },
        FranchiseList: { Read: 'Kmr.FranchiseList.Read' },
    }
}
